<template>
  <BContainer fluid v-if="ready" class="p-0 wrapper-embed">
      <BRow class="no-gutters justify-content-between align-items-center player-container"
            :data-index="player.index"
            :data-thumbnail="player.url"
            :key="player.url">


          <BCol cols="12" md="12"
                class="accordion item-gallery-effect "
                role="tablist">

                <div>
                    <div >
                        <div>
                            
                            
                              <div class="text-intro pt-3">
                                  <div class="d-flex align-self-center">
                                    <a href="https://www.icij.org/investigations/cyprus-confidential/oligarchs-offshore-clients" target="_parent"><img :src="getPicture(player.url, true)" width="auto" height="280px" />
                                        </a>
                                      <div>
                                        <h5 class="font-weight-300 text-primary fs-20px name-player">
                                           
                                            {{ player.title }}
                                            
                                        </h5>
                                      <h2 v-if="player.name" v-b-modal="`modal_${player.index}`"
                                          class="text-dark case_title name-player fs-xl-36px fs-lg-36px fs-md-27px fs-32px text-capitalize">
                                            
                                            <a class="text-dark" href="https://www.icij.org/investigations/cyprus-confidential/oligarchs-offshore-clients" target="_parent">
                                                {{player.name }}
                                            </a>
                                        </h2>

                                        <div>
                                            <label class=" fs-12px">{{ $t('appContent.entities_leak')}}: </label>
                                          </div>
                                          <div class="d-flex">
                                              <div class="p-2 text-center">
                                                  <h5 class="fs-44px name-player">{{ player.companies_nro }}</h5>
                                                  <label class="">Companies</label>
                                                </div>
                                                <div class="p-2 text-center" v-if="player.trusts_nro > 0">
                                                    <h5 class="fs-44px name-player">{{ player.trusts_nro }}</h5>                                       
                                                    <label class="">Trusts</label>
                                                </div>
                                            </div>
                                      </div>
                                  </div>                                 
                            </div>
  

                        </div>
                    </div>
                </div>
            



               <div>
 
               </div>

          </BCol>
          <IframModal :player="player"/>
      </BRow>

			<embeddable-footer class="position-relative" :sharing-options-values="{ url: 'https://www.reddit.com/submit?url=https%3A%2F%2Ficij.org' }">
				<template #sharing-button>
					<a class="p-1 btn-primary fs-16px" href="https://www.icij.org/investigations/cyprus-confidential/oligarchs-offshore-clients" target="_parent"> {{ $t('modal.btn_read') }} </a>
				</template>
			</embeddable-footer>

  </BContainer>
</template>

<script>

  import providerMixin from '@/mixins/player'
  import utils from '@/mixins/utils'
  import IframModal from '@/components/IframModal.vue'
  import { kebabCase } from "lodash";

  export default {
      name: 'Player',
      mixins: [utils, providerMixin],
      data() {
          return {
            ready: false,
            sharingOptionsValues: {}
          }
      },
      components: {
        IframModal
      },
      props: {
          content: {
              type: Object
          }
      },
      computed: {
        scaleEmbed() {
            if(window.innerWidth < 560)
                return this.player.scale * .6
            return this.player.scale * .5
        }
      },
      mounted() {
          this.$nextTick(() => {
              this.ready = true;
          })
      },
      methods: {
        kebabCase
      }
  }

</script>


<style lang="scss">
	.wrapper-embed {
		max-width: 620px;

		.player-container {
		}

		.embeddable-footer {
			&__brand {
				text-transform: uppercase;
				font-weight: 400;
				border: none;
                font-family: "headline-gothic-atf-rough-n1", sans-serif;
                font-weight: 400;
                font-style: normal;
                font-size: 28px;
			}
		}

        .name-player {
            font-family: "headline-gothic-atf-rough-n1", sans-serif;
            font-weight: 400;
            font-style: normal;
            font-size: 41px;
        }
	}

    .intro-embed {
        font-size: 14px;        
    }
  .card-image {
      width: 200px;
      cursor: url(~@/assets/img/plus.svg), auto;
      overflow: hidden;
      background-color: var(--app-color-white);
      &:focus {
          outline: none;
      }
      .__case-pic {
          width: 100%;
          height: auto;
      }
      @media (max-width: 720px) {
          .__case-pic {
              height: 27vh;
          }
      }
  }
  .--btn-modal {
      border: none;
      background-color: unset;
      color: var(--app-color-red);
      text-decoration-line: underline;
      font-weight: bold;
      &:focus {
          outline: none;
      }
  }

  @media (min-width: 1465px) {
      .container, .container-sm, .container-md, .container-lg, .container-xl {
          max-width: 1400px;
      }
  }
  .text-end {
      text-align: end !important;
  }
    .btn-read-more{
      background-color: var(--app-color-red);
      color: white;
      padding: .3rem 1.5rem;
      transition: opacity 300ms;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: fit-content;
      &:hover,&:focus{
          opacity: .9;
      }
  }

  .map_embed {
    position: absolute;
    width: 100%;
    max-height: 320px;
    overflow: hidden;

    .map_container_embed svg {
        background-color: #000 !important;
        path.active-residency {
            fill: var(--app-color-red) !important;
        }
    }
  }

  @media (max-width: 570px) {
    .card-image {
        width: 100%;
        margin: 0 auto;
    }
}
</style>
